import { createAction } from '@reduxjs/toolkit';

export const textActionType = {
  CHANGE_COLOR_NONDIGITAL: 'changeNonDigitalColor',
  CHANGE_TEXT_EDITING_STATUS: 'changeTextEditingStatus',
  CHANGE_NONDIGITAL_TEXT_LINE: 'changeNonDigitalTextLine',
};

export const showAddText = createAction('showAddText');
export const addTextElement = createAction('addTextElement');
export const initFontDict = createAction('initFontDict');
export const setFontRecentlyUsed = createAction('setFontRecentlyUsed');
export const initFontSizeRangeDict = createAction('initFontSizeRangeDict');
export const changeFontSize = createAction('changeFontSize');
export const initNonDigitalText = createAction('initNonDigitalText');
export const initNonDigitalTextLine = createAction('initNonDigitalTextLine');
export const changeNonDigitalColor = createAction(textActionType.CHANGE_COLOR_NONDIGITAL);
export const changeNonDigitalFontFace = createAction('changeNonDigitalFontFace');
export const changeNonDigitalFontCode = createAction('changeNonDigitalFontCode');
export const changeNonDigitalTextStyle = createAction('changeNonDigitalTextStyle');
export const changeNonDigitalFontSize = createAction('changeNonDigitalFontSize');
export const changeFontSizesAndImprintFits = createAction('changeFontSizesAndImprintFits');
export const hasInvalidCharacter = createAction('hasInvalidCharacter');
export const changeNonDigitalText = createAction('changeNonDigitalText');
export const changeNonDigitalTextLine = createAction(textActionType.CHANGE_NONDIGITAL_TEXT_LINE);
export const changeSuperUserText = createAction('changeSuperUserText');
export const changeStyleToAllNonDigitalText = createAction('changeStyleToAllNonDigitalText');
export const changeTheSecondTabData = createAction('changeTheSecondTabData');
export const clearText = createAction('clearText');
export const changeTextEditingStatus = createAction(textActionType.CHANGE_TEXT_EDITING_STATUS);
export const changeTextLineColor = createAction('changeTextLineColor');
